export const API_URL = import.meta.env.VITE_API_URL as string;
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string;
export const ENV = import.meta.env.MODE as string;
